module.exports = __webpack_public_path__ + "static/media/ic_ac_open_swing.f54afa33.png";